import { get } from 'lodash';

/**
 * manipulate controlling data and transform it in the format needed by rechart
 *
 * @param   data controlling data from the endpoint controlling/kpi
 * @param   keys kpis that wish to be shown as a line/bar on the chart
 * @return  array of objects containing a label for the XAxis and 1 value for each kpi passed
 */
export const getChartData = (data: object, keys: Array<string>) => {
  const chartData: object[] = [];
  const primaryData = get(data, keys[0], []);
  primaryData.forEach((record: { label: string; value: number }, index: number) => {
    let objectToPush = {
      label: record?.label,
      [keys[0]]: record?.value,
    };
    keys.unshift();
    keys.forEach((key) => {
      const dataForKey = get(data, key, [] as any[]);
      objectToPush[key] = dataForKey[index]?.value;
    });

    chartData.push(objectToPush);
  });
  return chartData;
};
/**
 * returns data for the loading state
 *
 * @param   data array of XAxis labels
 * @param   keys kpis that we initialize with 0
 * @param labelColumn
 * @return  array of objects containing a label for the XAxis and 1 value for each kpi passed
 */
export const getEmptyStateChart = (data: Array<{ label: string }>, keys: Array<string>, labelColumn?: string) => {
  const chartData: object[] = [];

  data.forEach((record: { label: string; [key: string]: string }) => {
    let objectToPush = {
      label: labelColumn ? record[labelColumn] : record?.label,
    };

    keys.forEach((key: string) => {
      // @ts-ignore
      objectToPush[key] = 0;
    });

    chartData.push(objectToPush);
  });
  return chartData;
};

export const getRandomChartColor = () => {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};
